import React from "react"
import ConfirmModal from "@/UI/Modals/ConfirmModal"
import { useTranslation } from "react-i18next"

interface DeleteCredentialsModalProps {
  onConfirm: () => void
  button: React.ReactElement
}

const DeleteCredentialsModal: React.FC<DeleteCredentialsModalProps> = ({ onConfirm, button }) => {
  const { t } = useTranslation()
  return (
    <ConfirmModal
      button={button}
      content={{
        type: "danger",
        title: "Switch to Kosmo billing",
        description: "Your existing keys will be completely deleted and billing will be done by us",
        cancelText: t("common.cancel"),
        okText: t("common.confirm"),
      }}
      onConfirm={onConfirm}
    />
  )
}

export default DeleteCredentialsModal
